import { useLang } from '@/i18n';
import css from './index.module.scss';
import EfFaqCollapse from '@elem/ui/ef-faq-collapse';
import { theme } from '../../config';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';

interface ItfItem {
    title: string;
    desc: string;
    img: string;
}

const I: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            title: t('I_item1_name'),
            desc: t('I_item1_text'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1783934406064-mqsvaa-compressed-Frame%202094656020.webp',
        },
        {
            title: t('I_item2_name'),
            desc: t('I_item2_text'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1783934403050-jswqmm-compressed-Frame%202094656019.webp',
        },
        {
            title: t('I_item3_name'),
            desc: t('I_item3_text'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1783934409471-o6r4lm-compressed-Frame%202094656021.webp',
        },
    ];

    useOnceInView('.stream-nl-I .title', () => {
        document.querySelector('.stream-nl-I .title')?.classList.add('enter');
        document.querySelector('.stream-nl-I .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-I .content')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-I GtmModuleData-section space`} id="stream-nl-I" data-section-id={'stream-nl-I'}>
            <div className="info">
                <h2 className="title ani-1">{t('I_title')}</h2>
                <p className="desc ani-2">{t('I_desc')}</p>
            </div>
            <div className="content ani-3">
                <EfFaqCollapse type="img" lists={items} title="" theme={theme} btnObj={{ url: '/nl/oasis-home-energy-management-system', text: t('I_btn') }} />
            </div>
        </div>
    );
};

export default I;
